export enum MediaRecordingUploadRetryKindEnum {
  ChunkUpload = 'chunk_upload',
  ServerProcessing = 'server_processing',
}
